var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.597 1.665a2.248 2.248 0 0 0-3.194 0c-.57.576-1.406.8-2.188.587A2.248 2.248 0 0 0 5.45 3.848 2.248 2.248 0 0 1 3.848 5.45a2.248 2.248 0 0 0-1.596 2.765 2.248 2.248 0 0 1-.587 2.188 2.248 2.248 0 0 0 0 3.194c.576.57.8 1.406.587 2.188a2.248 2.248 0 0 0 1.596 2.765 2.248 2.248 0 0 1 1.602 1.602 2.248 2.248 0 0 0 2.765 1.596 2.248 2.248 0 0 1 2.188.587 2.25 2.25 0 0 0 3.194 0c.57-.576 1.406-.8 2.188-.587a2.248 2.248 0 0 0 2.765-1.596 2.248 2.248 0 0 1 1.602-1.602 2.248 2.248 0 0 0 1.596-2.765 2.249 2.249 0 0 1 .587-2.188 2.248 2.248 0 0 0 0-3.194 2.248 2.248 0 0 1-.587-2.188 2.248 2.248 0 0 0-1.596-2.765 2.248 2.248 0 0 1-1.602-1.602 2.248 2.248 0 0 0-2.765-1.596 2.248 2.248 0 0 1-2.188-.587Zm-1.345 13.566a.5.5 0 0 0-.504 0L8.987 16.84a.5.5 0 0 1-.738-.55l.72-2.978a.5.5 0 0 0-.165-.501L6.42 10.819a.5.5 0 0 1 .28-.882l3.172-.26a.5.5 0 0 0 .417-.297l1.253-2.853a.5.5 0 0 1 .916 0L13.71 9.38a.5.5 0 0 0 .417.297l3.172.26a.5.5 0 0 1 .28.882l-2.384 1.992a.5.5 0 0 0-.165.5l.72 2.979a.5.5 0 0 1-.738.55l-2.761-1.609Z",
    fill: "#D59518"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPremium);
export default __webpack_public_path__ + "static/media/icon_premium.a6ee47861166539a1c3b524e6a23691c.svg";
export { ForwardRef as ReactComponent };